<template>
    <div>
        <el-dialog title="保洁服务合作协议" :visible.sync="jcxy" :close-on-click-modal="false" width="800px" center>
            <el-form :inline="true">
              <el-row>

                        <el-form-item label="保洁合同类型">
                            <el-select v-model="eventType"    placeholder="请选择合同类型" filterable>
                                <el-option    label="保洁服务合作协议" :value="105"></el-option>
                                <el-option    label="保洁服务合作协议-美团" :value="1052"></el-option>
                                <el-option    label="保洁服务合作协议-员工制" :value="1053"></el-option>
                            </el-select>
                        </el-form-item>

              </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="服务者">
                            <el-select v-model="reqCreate.personId" @change="selectPerson" filterable clearable collapse-tags>
                                <el-option v-for="(item, key) in singList" :key="key" :label="item.workerName+item.workerTel" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名（乙方）">
                            <el-input v-model="reqCreate.name" style="width:130px" clearable show-word-limit placeholder></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="电话">
                            <el-input v-model="reqCreate.tel" style="width:233px" clearable maxlength="11" show-word-limit placeholder></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号码">
                            <el-input v-model="reqCreate.idCard" style="width:233px" clearable maxlength="18" show-word-limit placeholder></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="联系地址">
                            <el-input v-model="reqCreate.address" style="width:623px" show-word-limit placeholder clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="">
                            本人({{reqCreate.name}})因, &nbsp;&nbsp;&nbsp;&nbsp;
                            <el-input v-model="reqCreate.reason" style="width:550px" show-word-limit placeholder clearable></el-input>
                            <br /><br />在 <el-date-picker v-model="reqCreate.dateStart" style="width:230px" type="datetime" placeholder="开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                            至 <el-date-picker v-model="reqCreate.dateEnd" style="width:230px" type="datetime" placeholder="截止日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                            时段内无法进行接单
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <!-- <el-form-item label="隔离地点">
                            <el-input v-model="formData.gldd" style="width:220px" show-word-limit placeholder clearable></el-input>
                        </el-form-item> -->
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同日期" prop="data1">
                            <el-date-picker v-model="reqCreate.qsrq" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy=false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
        </el-dialog>

        <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
            <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0" style="width:870px;height:800px"></iframe>

            <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import wmsApi from "@/script/api/wmsApi";
import globalData from '@/components/common/globaldata/global.data';
export default {
    data() {
        return {
            eventType:105,

            id: null,
            jcxy: false,
            PDFVisible: false,
            contractUrl: null,
            cityList: [],

            field105: {},
            singList: [],
            choosePerson: {}, //下拉框所选人
            reqCreate: {
                personId: null,
                qsrq: null,

                cityId:null,
                workerNo:null,
                name: null,
                tel: null,
                idCard: null,
                address: null,
                dateStart: null,
                dateEnd: null,
                reason: null,

                tempSignData: {},
                fraId: null,
                operId: null,
                operName: null,

                contractFileId: null,
                templateNo: null,
                contractNo: null,
                contractType: null,
                creditCode: null
            }
        };
    },
    methods: {
        showDetail(workerNo) {
            this.getAllCity();
            this.jcxy = true;

            this.reqCreate = {
                personId: null,
                qsrq: null,

                cityId:null,
                workerNo:workerNo,
                name: null,
                tel: null,
                idCard: null,
                address: null,
                dateStart: null,
                dateEnd: null,
                reason: null,

                tempSignData: {},
                fraId: null,
                operId: null,
                operName: null,

                contractFileId: null,
                templateNo: null,
                contractNo: null,
                contractType: null
            };

            this.loadSingList();
        },

        loadSingList() {
            let that=this;
            contract.$ajaxGetAllWorkerList({fraId:293}).then((res) => {
                if (res.data.errno == 0) {
                    this.singList = res.data.data;
                    this.singList.forEach(s=>{
                        if(s.workerNo==that.reqCreate.workerNo){
                            that.reqCreate.personId=s.id;
                            that.selectPerson(s.id);
                        }
                    })
                }
            });
        },
        selectPerson(id) {
            if (id == null || id == '') {
                this.reqCreate.name = '';
                this.reqCreate.tel = '';
                this.reqCreate.idCard = '';
                this.reqCreate.cityId='';
                this.reqCreate.creditCode='';
            }
            let that = this;
            this.singList.forEach((e) => {
                if (e.id == id) {
                    that.choosePerson = e;
                }
            });
            if (id != null) {
                this.reqCreate.cityId=this.choosePerson.cityId;
                  this.reqCreate.workerNo= this.choosePerson.workerNo;
                this.reqCreate.name = this.choosePerson.workerName;
                this.reqCreate.tel = this.choosePerson.workerTel;
                this.reqCreate.idCard = this.choosePerson.idCrad;
                this.reqCreate.creditCode=this.choosePerson.creditCode;
            }
        },
        checkFm() {
            // if (this.reqCreate.cityId == null || this.reqCreate.cityId == '') {
            //     this.$message.error('请选择城市');
            //     return false;
            // }
            if (this.reqCreate.name == null || this.reqCreate.name == '') {
                this.$message.error('请选择服务者，或输入姓名');
                return false;
            }
            if (this.reqCreate.tel == null || this.reqCreate.tel == '' || this.reqCreate.tel.length != 11) {
                this.$message.error('请选择服务者，或输入正确的电话号码');
                return false;
            }
            if (this.reqCreate.idCard == null || this.reqCreate.idCard == '' || this.reqCreate.idCard.length != 18) {
                this.$message.error('请选择服务者，或输入正确的身份证');
                return false;
            }
            if (this.reqCreate.address == null || this.reqCreate.address == '') {
                this.$message.error('请输入联系地址');
                return false;
            }
            // if (this.reqCreate.reason == null||this.reqCreate.reason == '') {
            //     this.$message.error('请输入原因');
            //     return false;
            // }
            // if (this.reqCreate.dateStart == null||this.reqCreate.dateStart == '') {
            //     this.$message.error('请选择开始日期');
            //     return false;
            // }
            // if (this.reqCreate.dateEnd == null||this.reqCreate.dateEnd == '') {
            //     this.$message.error('请选择结束日期');
            //     return false;
            // }

            if (this.reqCreate.qsrq == null || this.reqCreate.qsrq == '') {
                this.$message.error('请选择合同日期');
                return false;
            }

            return true;
        },
        fillTemplate() {
            let field105 = {
                Contract_no: null,
                year: this.reqCreate.qsrq.substring(0, 4),
                month: this.reqCreate.qsrq.substring(5, 7) * 1,
                day: this.reqCreate.qsrq.substring(8, 10) * 1,
                name: this.reqCreate.name,
                id_card: this.reqCreate.idCard,
                address: this.reqCreate.address,
                tel: this.reqCreate.tel,
                // gz:
                // gz1
                name2: null,
                reason: null,
                year_start: null,
                month_start: null,
                day_start: null,
                year_end: null,
                month_end:null,
                day_end: null,
                year2: null,
                month2: null,
                day2: null,
                name3:null,
                // faren: '王松青', //后台配置了
                cityId: this.reqCreate.cityId,
                q_date: this.reqCreate.qsrq,
                q_date2: this.reqCreate.qsrq,
                q_date3: this.reqCreate.qsrq,
                // gz2:''
            };

            if (this.reqCreate.dateStart != null && this.reqCreate.dateStart != '') {
                // field105
                field105.year_start = this.reqCreate.dateStart.substring(0, 4);
                field105.month_start = this.reqCreate.dateStart.substring(5, 7) * 1;
                field105.day_start = this.reqCreate.dateStart.substring(8, 10) * 1;
            }

            if (this.reqCreate.dateEnd != null && this.reqCreate.dateEnd != '') {
                field105.year_end = this.reqCreate.dateEnd.substring(0, 4);
                field105.month_end = this.reqCreate.dateEnd.substring(5, 7) * 1;
                field105.day_end = this.reqCreate.dateEnd.substring(8, 10) * 1;

                field105.name2= this.reqCreate.name;
                field105.reason= this.reqCreate.reason;
                 field105.name3= this.reqCreate.name;

                field105.year2 = this.reqCreate.qsrq.substring(0, 4);
                field105.month2 = this.reqCreate.qsrq.substring(5, 7);
                field105.day2 = this.reqCreate.qsrq.substring(8, 10);
            }

            this.field105 = field105;
            return field105;
        },
        yulan() {
            if (!this.checkFm()) {
                return;
            }
            let temFields = this.fillTemplate();
            this.reqCreate.tempSignData = temFields;

            let reqData = {
                cityId: this.reqCreate.cityId,
                fraId : 293,//globalData.franchisee.id,
                eventType: this.eventType, //方舱合同
                name: '保洁服务合作协议',
                simpleFormFields: temFields,
                creditCode:this.reqCreate.creditCode
            };
            if(this.eventType==1052||this.eventType==1053){
              reqData.cityId='';//保洁美团、员工制的不要城市
            }

            const loading = this.$loading({
                lock: true,
                text: '努力生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            contract
                .$ajaxPreviewFile(reqData)
                .then((res) => {
                    if (res.data.errno == 0) {
                        loading.close();
                        // console.log(res);
                        this.contractUrl = res.data.data.downloadUrl;
                        this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                        this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                        this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                        this.PDFVisible = true;
                    } else {
                        loading.close();
                        this.$message({
                            showClose: true,
                            message: res.data.data,
                            type: 'warning',
                            duration: 8000
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        sendContractBtn() {
            const loading = this.$loading({
                lock: true,
                text: '发送合同中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            this.reqCreate.fraId =293;
            this.reqCreate.operId = globalData.userInfo.id;
            this.reqCreate.operName = globalData.userInfo.userName;

            // this.reqCreate.name = this.choosePerson.name;
            // this.reqCreate.idCard = this.choosePerson.idCard;
            // this.reqCreate.address = this.choosePerson.address;
            // this.reqCreate.tel = this.choosePerson.tel;

            this.reqCreate.contractType = this.eventType;

            contract.$ajaxWorkerContractSignTerminated(this.reqCreate).then((res) => {
                loading.close();
                if (res.data.errno == 0) {
                    this.$message.success('合同已发送,请尽快联系服务者签署！');
                    // this.querySearch();
                    this.$emit('querySearch');
                    this.PDFVisible = false;
                    this.jcxy = false;
                } else {
                    this.$message.warning(res.data.data);
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi
                .$axiosgetallCity()
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.cityList = res.data.data;
                    }
                });
        },
    }
};
</script>
<style lang="">
</style>
